export default __webpack_public_path__ + "static/media/img_12.ff90599f.JPG";